module.exports = __webpack_public_path__ + "assets/img/thumb-BodyLux.09242472.jpg";